import { Controller } from '@hotwired/stimulus'

// Minimal controller: reloads the page when triggered by an external event
// (e.g. conversion-note:saved / conversion-note:deleted). Used on pages that
// are themselves the full data view, where a reload is the correct "live
// update" behavior.
export default class extends Controller {
  reload() {
    window.location.reload()
  }
}
